import { faCheck, faClose, faExclamation, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import ptBR from "date-fns/locale/pt-BR";
import { format, parse } from "date-fns";


const StatusAnalise = ({ value }) => {
    switch (value) {
        case 1:
            return (
                <Tooltip title="Não avaliado" placement="right">
                    <div className="status_digitacao">
                        <FontAwesomeIcon icon={faRefresh} />
                    </div>
                </Tooltip>
            )
        case 2:
            return (
                <Tooltip title="Favorável" placement="right">
                    <div className="status_homologado">
                        <FontAwesomeIcon icon={faCheck} />
                    </div>
                </Tooltip>
                
            )
        case 3:
            return (
                <Tooltip title="Favorável com ressalvas" placement="right">
                    <div className="status_revisao">
                        <FontAwesomeIcon icon={faExclamation} />
                    </div>
                </Tooltip>
            )
        default:
            return (
                <Tooltip title="Reprovado" placement="right">
                    <div className="status_cancelado">
                        <FontAwesomeIcon icon={faClose} />
                    </div>
                </Tooltip>
            )
    }
}

const StatusParecerAnalise = ({ value }) => {
    switch (value) {
        case 1:
            return (
                <Tooltip title="Não avaliado" placement="right">
                    <div className="status_texto">
                        <div className="status_digitacao">
                            <FontAwesomeIcon icon={faRefresh} />
                        </div>
                        Não avaliado
                    </div>
                </Tooltip>
            )
        case 2:
            return (
                <Tooltip title="Favorável" placement="right">
                    <div className="status_texto">
                        <div className="status_homologado">
                            <FontAwesomeIcon icon={faCheck} />
                        </div>
                        Favorável
                    </div>
                </Tooltip>
                
            )
        case 3:
            return (
                <Tooltip title="Favorável com ressalvas" placement="right">
                    <div className="status_texto">
                        <div className="status_aguardando">
                            <FontAwesomeIcon icon={faExclamation} />
                        </div>
                        Favorável com ressalvas
                    </div>
                </Tooltip>
            )
        default:
            return (
                <Tooltip title="Reprovado" placement="right">
                    <div className="status_texto">
                        <div className="status_cancelado ">
                            <FontAwesomeIcon icon={faClose} />
                        </div>
                        Reprovado
                    </div>
                </Tooltip>
            )
    }
}

const verificaSituacaoDaAnalise = (params, value) => {
    if (params?.row?.SolicitacaoDeAcesso.Situacao !== 1 && value !== 1 && params?.row?.Situacao !== 1) {
        return <StatusParecerAnalise value={params.value} />;
    } else {
        return (
            <Tooltip title="Não avaliado" placement="right">
                <div className="status_texto">
                    <div className="status_digitacao">
                        <FontAwesomeIcon icon={faRefresh} />
                    </div>
                    Não avaliado
                </div>
            </Tooltip>
        );
    }
};

const columnsAnaliseSolicitacaoAcesso = [
    {
        field: 'ParecerGeral',
        headerName: 'Parecer',
        renderCell: (params) => {
            return verificaSituacaoDaAnalise(params, params.value);
        },
        flex: 0.7
    },
    {
        field: 'DataApresentacao', headerName: 'Data de apresentação', width: 200,
        renderCell: (params) => {
            let dataFormatada = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            })

            return dataFormatada;
        }
    },
    { field: 'DataAnalise', headerName: 'Data de análise', width: 200,
        renderCell: (params) => {
            let dataFormatada = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            })

            return dataFormatada;
        } 
    },
    {
        field: 'ParecerDocumentos',
        headerName: 'Parecer dos documentos',
        renderCell: (params) => {
            return verificaSituacaoDaAnalise(params, params.value);
        },
        flex: 1,
    },
    {
        field: 'ParecerEquipamento',
        headerName: 'Parecer dos equipamentos',
        renderCell: (params) => {
            return verificaSituacaoDaAnalise(params, params.value);
        },
        flex: 1,
    },
    {
        field: 'ParecerProjeto',
        headerName: 'Parecer do projeto',
        renderCell: (params) => {
            return verificaSituacaoDaAnalise(params, params.value);
        },
        flex: 1,
    },
    {
        field: 'ParecerViabTecnica',
        headerName: 'Parecer da viabilidade técnica',
        renderCell: (params) => {
            return verificaSituacaoDaAnalise(params, params.value);
        },
        flex: 1,
    },
]

export { columnsAnaliseSolicitacaoAcesso };